<template>
	<div>
		<TilteParallax>
			<template v-slot:title>
				Pedidos
			</template>

			<template v-slot:subtitle>
				Listado de ultimos pedidos.
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							color="default"
							:loading="ui.loading"
							v-bind="attrs"
							v-on="on"
							elevation="5"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							@click="$router.push({ name: 'SalesOrderCreate' })"
						>
							Nuevo
						</v-list-item>

						<template v-if="selected.length > 0">
							<v-list-item @click="receiveSalesOrdersSelected()">
								<v-list-item-title>
									Recibir pedidos
								</v-list-item-title>
							</v-list-item>

							<v-list-item @click="exportSalesOrdersSelected()">
								<v-list-item-title>
									Exportar
								</v-list-item-title>
							</v-list-item>
						</template>
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center" class="pt-0 mt-0">
				<v-col cols="12" md="9" class="pb-0">
					<v-text-field
						dense
						clearable
						outlined
						label="Criterio de busqeuda"
						v-model="ui.filters.search"
					></v-text-field>
				</v-col>

				<v-col cols="12" md="1" class="d-flex pb-0">
					<v-btn @click="get()" text block :loading="ui.geting">
						<v-icon dark>mdi-cached</v-icon>
					</v-btn>
				</v-col>

				<v-col cols="12" md="10" class="pb-0 pt-0">
					<v-expansion-panels>
						<v-expansion-panel>
							<v-expansion-panel-header color="#F5F5F5">
								<v-badge
									:color="
										filtersActive ? 'green' : 'transparent'
									"
									:content="filtersActive"
								>
									Otros filtros
								</v-badge>
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-form
									refs="formFilters"
									v-model="ui.forms.filters"
									lazy-validation
									@submit.prevent=""
								>
									<v-row>
										<v-col cols="12" md="3" class="pb-0">
											<v-select
												dense
												outlined
												clearable
												:items="Users"
												label="Usuario"
												v-model="ui.filters.user_id"
											></v-select>
										</v-col>

										<v-col cols="12" md="3" class="pb-0">
											<v-text-field
												dense
												outlined
												type="date"
												label="Fecha inicio"
												clearable
												v-model="ui.filters.date_start"
											></v-text-field>
										</v-col>

										<v-col cols="12" md="3" class="pb-0">
											<v-text-field
												dense
												outlined
												type="date"
												label="Fecha final"
												clearable
												:rules="[
													ui.v.min(
														'date',
														ui.filters.date_start,
														ui.filters.date_end
													),
												]"
												v-model="ui.filters.date_end"
											></v-text-field>
										</v-col>

										<v-col cols="12" md="3" class="pb-0">
											<v-select
												dense
												outlined
												clearable
												label="Status"
												:items="Status"
												v-model="ui.filters.status_id"
											></v-select>
										</v-col>
									</v-row>
								</v-form>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>

				<v-col cols="12" md="10">
					<v-data-table
						v-model="selected"
						show-select
						:headers="headers"
						:loading="ui.geting"
						:items="Items"
						:search="ui.filters.search"
					>
						<!-- Slot Customer -->
						<template v-slot:item.customer="{ item }">
							<router-link
								:to="{
									name: 'CustomerShow',
									params: { id: item.customer.id },
								}"
							>
								{{ item.customer.name }}
							</router-link>
						</template>

						<!-- Slot Created_at -->
						<!-- <template v-slot:item.created_at="{ item }">
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<span
										color="primary"
										dark
										v-bind="attrs"
										v-on="on"
									>
										{{ item.created_at_for_humans }}
									</span>
								</template>
								<span>
									{{ item.created_at }}
								</span>
							</v-tooltip>
						</template> -->

						<template v-slot:item.created_at_new="{ item }">
							<ChipCreatedAt
								:date="item.created_at_new"
								:format="'YYYY-MM-DD HH:mm:ss'"
							/>
						</template>

						<!-- Slot Exported_at -->
						<template v-slot:item.exported_at="{ item }">
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<span
										color="primary"
										dark
										v-bind="attrs"
										v-on="on"
									>
										{{ item.exported_at_for_humans }}
									</span>
								</template>
								<span>
									{{ item.exported_at }}
								</span>
							</v-tooltip>
						</template>

						<!-- Slot Status -->
						<template v-slot:item.status="{ item }">
							<chip-status :status="item.status" small />
						</template>

						<!-- Slot Actions -->
						<template v-slot:item.actions="{ item }">
							<router-link
								:to="{
									name: 'SalesOrderShow',
									params: { id: item.id },
								}"
							>
								<span class="font-weight-bold">
									Ver
								</span>
							</router-link>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-container>

		<!-- SalesOrdersStatusUpdate Component -->
		<SalesOrdersStatusUpdate />
	</div>
</template>

<script>
import axios from "axios";
import { v } from "@/main";
import moment from "moment";
import { EventBus } from "@/main";
import SalesOrder from "@/clas/SalesOrder";
import TilteParallax from "@/components/TilteParallax";
import SalesOrdersStatusUpdate from "@/components/SalesOrder/StatusUpdate";

// Class
import Csv from "@/../../GeneralComponents/Class/Csv";

// Components
import ChipCreatedAt from "@/../../GeneralComponents/ChipCreatedAt";
import ChipStatus from "@/components/SalesOrder/ChipStatus";

export default {
	name: "Index",

	components: {
		TilteParallax,
		SalesOrdersStatusUpdate,
		ChipCreatedAt,
		ChipStatus,
	},

	data() {
		return {
			session: null,

			data: {
				salesorders: [],
			},

			items: [],

			selected: [],

			headers: [
				{ text: "#", value: "id" },
				{ text: "Cliente", value: "customer" },
				{ text: "Usuario", value: "user.email" },
				{ text: "Metodo de envío", value: "shipping_method.name" },
				{ text: "Partidas", value: "articles_sale_orders.length" },
				{ text: "Fecha", value: "created_at_new" },
				{ text: "Status", value: "status" },
				{ text: "Ultima exportación", value: "exported_at" },
				{ text: "Acciones", value: "actions", sortable: false },
			],

			ui: {
				filters: {
					search: null,
					user_id: null,
					date_end: null,
					status_id: null,
					date_start: null,
				},

				forms: {
					filters: true,
				},

				v: v,

				geting: false,

				loading: false,
			},
		};
	},

	created() {
		this.session = JSON.parse(localStorage.getItem("session"));

		this.get();

		EventBus.$on("SalesOrdersStatusUpdated", () => {
			this.selected = [];

			this.getSalesOrders();
		});

		EventBus.$on("SalesOrderGet", () => {
			this.getSalesOrders();
		});
	},

	methods: {
		async getSalesOrders() {
			try {
				let response = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/salesorder`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.state.acount.token}`,
						},
					}
				);

				this.data.salesorders = response.data.data;

				this.$store.commit(
					"SET_SALES_ORDER_LAST_ID",
					response.data.data[0]?.id ?? null
				);

				// this.data.salesorders = response.data.data.map((item) => {
				// 	return {
				// 		...item,
				// 		articles: item.articles.map((article) => {
				// 			return {
				// 				...article,
				// 				...article.pivot,
				// 			};
				// 		}),
				// 	};
				// });
			} catch (error) {
				try {
					switch (error.response.status) {
						case 401:
							this.$store.dispatch("setTokenRefreshDialog", true);
							break;
						default:
							EventBus.$emit("Error", {
								error: error,
								alertShow: true,
							});
							break;
					}
				} catch (e) {
					EventBus.$emit("Error", { error: error, alertShow: true });
				}
			}
		},

		async get() {
			this.ui.geting = true;

			await this.getSalesOrders();

			this.ui.geting = false;
		},

		async exportSalesOrdersSelected() {
			try {
				this.ui.loading = true;

				let exceptions = this.selected
					.filter((item) => item.status_id != 2)
					.map((item) => `#${item.id}`);

				if (exceptions.length) {
					if (
						!confirm(
							`¡Atención! Se omitirán ${
								exceptions.length
							} registros.\n\nEl estado de los registros no permite realizar esta acción.\nRegistros omitidos: ${exceptions.join(
								", "
							)}`
						)
					) {
						return false;
					}
				}

				let salesOrdersIds = this.selected
					.filter((item) => item.status_id == 2)
					.map((item) => item.id);

				if (salesOrdersIds.length) {
					let salesOrder = new SalesOrder();

					let salesOrders = await salesOrder.export(salesOrdersIds);

					salesOrders = salesOrders.map((salesOrder) => {
						return {
							...salesOrder,
							articles: salesOrder.articles.map((article) => {
								return {
									...article,
									...article.pivot,
								};
							}),
						};
					});

					let template = salesOrders.flatMap((item) => {
						let salesOrder = new SalesOrder(item);

						return salesOrder.templateCreate();
					});

					let csv = new Csv(template);

					await csv.toCsv({
						name: `Template OV ${salesOrdersIds.join(", ")}`,
					});

					csv.csvDownload();

					await salesOrder.exportedUpdateMasive(salesOrdersIds);

					this.selected = [];

					this.getSalesOrders();
				}
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},

		async receiveSalesOrdersSelected() {
			try {
				let exceptions = this.selected.filter(
					(item) => item.status_id != 1
				);

				if (exceptions.length > 0) {
					if (
						!confirm(
							`¡Atención!\nSe omitirán ${exceptions.length} de ${
								this.selected.length
							} registros seleccionados.\nEl estado de estos registros no permiten realizar esta acción.\nRegistros omitidos: ${exceptions
								.map((item) => `#${item.id}`)
								.join(", ")}`
						)
					) {
						return false;
					}
				}

				let filtered = this.selected.filter(
					(item) => item.status_id == 1
				);

				if (filtered.length == 0) {
					return (this.selected = []);
				}

				EventBus.$emit("SalesOrdersStatusUpdate", filtered);
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.loading = false;
			}
		},

		hasRol(rolIdRequired) {
			if (
				this.$store.state.acount.user.roles.find(
					(rol) => rol.id === rolIdRequired
				) === undefined
			) {
				return false;
			}

			return true;
		},
	},

	computed: {
		Items() {
			let items = this.data.salesorders;

			if (this.ui.forms.filters) {
				// Filter User
				if (this.ui.filters.user_id) {
					items = items.filter(
						(item) => item.user_id == this.ui.filters.user_id
					);
				}

				// Filter Date Start
				if (this.ui.filters.date_start) {
					items = items.filter(
						(item) =>
							moment(item.created_at_new, [
								"YYYY-MM-DD h:mm:ss a",
							]).format("YYYY-MM-DD") >=
							this.ui.filters.date_start
					);
				}

				// Filter Date End
				if (this.ui.filters.date_end) {
					items = items.filter(
						(item) =>
							moment(item.created_at_new, [
								"YYYY-MM-DD h:mm:ss a",
							]).format("YYYY-MM-DD") <= this.ui.filters.date_end
					);
				}

				// Filter Status
				if (this.ui.filters.status_id) {
					items = items.filter(
						(item) => item.status_id == this.ui.filters.status_id
					);
				}
			}

			return items;
		},

		Status() {
			return [
				{ text: "Creado", value: 1 },
				{ text: "Recibido", value: 2 },
			];
		},

		Users() {
			let users = new Set(this.data.salesorders.map((item) => item.user));

			users = [...users];

			return users.map((item) => {
				return {
					text: item?.email,
					value: item?.id,
				};
			});
		},

		filtersActive() {
			let counter = 0;

			for (let i in this.ui.filters) {
				if (this.ui.filters[i]) {
					counter++;
				}
			}

			return counter;
		},
	},
};
</script>

<style lang="css" scoped></style>
